
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import VTable from '@/components/shared/table/VTable.vue';
import headers from './headers';
import { Tag } from '@/interfaces/models/Tag';
import { PrintGroups } from '../../interfaces/models/PrintGroups';

@Component({
  components: { VTable },
})
export default class PrintGroupsTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Tag[];
  @Prop({ type: Number, required: true }) public total!: number;

  public headers: ColumnHeader[] = headers;

  public edit(item: PrintGroups) {
    this.$router.push({ name: 'printGroups.edit', params: { id: item._id }, query: { ...this.$route.query } });
  }
}
